var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { ref: "containerPaletteRef", staticClass: "c-palette-picker" },
    [
      _c(
        "div",
        { staticClass: "c-palette-picker__header" },
        [
          _c("h3", [_vm._v("Alternation")]),
          _vm._v(" "),
          _c(_setup.CDropdown, {
            staticClass: "w-50",
            attrs: {
              options: _setup.paletteTypesList,
              value: _setup.paletteType,
              name: "paletteType",
              placeholder: "Select Palette Type",
            },
            on: { input: _setup.onPaletteTypeChange },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "c-palette-picker__colors" }, [
        _c(
          "div",
          { staticClass: "c-palette-picker__colors-header" },
          [
            _c("h3", [_vm._v("Colors")]),
            _vm._v(" "),
            _c(_setup.CButton, {
              attrs: { size: "icon", icon: "plus" },
              on: { click: () => _setup.addColorStop() },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "c-palette-picker__colors-list" },
          [
            _c(_setup.DraggableList, {
              attrs: {
                "item-key": "index",
                "hide-counter": "",
                draggable: "",
                selected: "-1",
              },
              scopedSlots: _vm._u([
                {
                  key: "item",
                  fn: function ({ element }) {
                    return [
                      _c(
                        "div",
                        { staticClass: "c-palette-picker__colors-color" },
                        [
                          _c("div", {
                            staticClass: "c-palette-picker__colors-preview",
                            style: { backgroundColor: element.hex },
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return (() =>
                                  _setup.openColorPickerPopper(
                                    element.index
                                  )).apply(null, arguments)
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              _vm._s(element.hex.replace("#", "").toUpperCase())
                            ),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(_setup.CButton, {
                        attrs: {
                          disabled: !_setup.canDeleteColor,
                          size: "icon",
                          icon: "trash-can",
                        },
                        on: {
                          click: () => _setup.onDeleteColor(element.index),
                        },
                      }),
                    ]
                  },
                },
              ]),
              model: {
                value: _setup.paletteColorListSorted,
                callback: function ($$v) {
                  _setup.paletteColorListSorted = $$v
                },
                expression: "paletteColorListSorted",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { ref: "solidColorRef", staticClass: "color-selector-wrapper" },
        [
          _setup.openColorPicker
            ? _c(_setup.CSolidColor, {
                staticClass: "color-picker",
                attrs: { mode: _vm.mode },
                on: { input: _setup.onUpdateColor },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "footer",
                      fn: function () {
                        return [
                          _c(
                            "div",
                            {
                              staticClass: "d-flex justify-content-end mt-auto",
                            },
                            [
                              _c(_setup.CButton, {
                                staticClass: "mr-2",
                                attrs: {
                                  variant: "outline-primary",
                                  size: "sm",
                                  text: "CANCEL",
                                },
                                on: { click: _setup.onClosePopper },
                              }),
                              _vm._v(" "),
                              _c(_setup.CButton, {
                                attrs: {
                                  variant: "primary",
                                  size: "sm",
                                  text: "APPLY",
                                },
                                on: { click: _setup.onClosePopper },
                              }),
                            ],
                            1
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  104726877
                ),
                model: {
                  value: _setup.currentColor,
                  callback: function ($$v) {
                    _setup.currentColor = $$v
                  },
                  expression: "currentColor",
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }